import React from 'react'

const Spinner = () => {
  return (
    <div className="spinner-father">
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  )
}

export default Spinner
